"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _navigationBarModule = _interopRequireDefault(require("./navigationBar.module.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var NavigationBar = function NavigationBar(props) {
  var id = props.id,
      navItems = props.navItems,
      activeItemKey = props.activeItemKey,
      onNavItemSelect = props.onNavItemSelect,
      variant = props.variant,
      stepCounter = props.stepCounter;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var onMouseEnter = function onMouseEnter(key) {
    return setIsHovered(key);
  };

  var onMouseLeave = function onMouseLeave() {
    return setIsHovered(null);
  };

  var checkItemPosition = function checkItemPosition(tabs, key) {
    var style = _navigationBarModule.default["nav-link"];

    if (variant === "wizard" && tabs.map(function (navItem) {
      return navItem.key;
    }).indexOf(key) > tabs.map(function (activeItem) {
      return activeItem.key;
    }).indexOf(activeItemKey) && tabs.map(function (navItem) {
      return navItem.key;
    }).indexOf(key) < tabs.length) {
      style = _navigationBarModule.default["nav-link-blocked"];
    }

    return style;
  };

  return _react.default.createElement("ul", {
    id: id ? id : null,
    className: (0, _classnames.default)(_themeModule.default.arag, _navigationBarModule.default["nav"], _navigationBarModule.default["nav-tabs"], _navigationBarModule.default["nav-justified"]),
    role: "tablist"
  }, navItems.map(function (item, index) {
    return _react.default.createElement("li", {
      id: id ? "".concat(id, "_item_").concat(item.key) : null,
      key: item.key,
      className: (0, _classnames.default)(_navigationBarModule.default["nav-item"], activeItemKey === item.key ? _navigationBarModule.default["active"] : "", variant === "wizard" ? _navigationBarModule.default["wiz-tab"] : "", item.disabled ? _navigationBarModule.default["disabled"] : ""),
      onClick: onNavItemSelect ? function () {
        return onNavItemSelect(item.key);
      } : null,
      onMouseEnter: item.info ? function () {
        return onMouseEnter(item.key);
      } : null,
      onMouseLeave: item.info ? function () {
        return onMouseLeave();
      } : null
    }, _react.default.createElement("a", {
      id: id ? "".concat(id, "_item_").concat(item.key, "_wrapper") : null,
      className: (0, _classnames.default)(checkItemPosition(navItems, item.key), item.info && isHovered === item.key ? _navigationBarModule.default['tooltip-wrapper'] : "")
    }, stepCounter ? _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("strong", {
      id: id ? "".concat(id, "_item_").concat(item.key, "_label") : null
    }, index + 1), item.label) : item.label, item.counter && _react.default.createElement("span", {
      id: id ? "".concat(id, "_item_").concat(item.key, "_counter") : null,
      className: _navigationBarModule.default["counter"]
    }, item.counter), item.info && isHovered === item.key && _react.default.createElement("div", {
      id: id ? "".concat(id, "_item_").concat(item.key, "_tooltip") : null,
      className: (0, _classnames.default)(_navigationBarModule.default["tooltip"], _navigationBarModule.default["fade"], _navigationBarModule.default["top"], _navigationBarModule.default["in"], _navigationBarModule.default["centered"]),
      role: "tooltip"
    }, _react.default.createElement("div", {
      id: id ? "".concat(id, "_item_").concat(item.key, "_arrow") : null,
      className: _navigationBarModule.default["tooltip-arrow"]
    }), _react.default.createElement("div", {
      id: id ? "".concat(id, "_item_").concat(item.key, "_info") : null,
      className: _navigationBarModule.default["tooltip-inner"]
    }, item.info))));
  }));
};

NavigationBar.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** The variant of the navigation bar tabs */
  variant: _propTypes.default.oneOf(["wizard"]),

  /** Callback invoked on tab click */
  onNavItemSelect: _propTypes.default.func,

  /** The nav items - tabs */
  navItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    label: _propTypes.default.string.isRequired,
    info: _propTypes.default.string,
    counter: _propTypes.default.string,
    disabled: _propTypes.default.bool
  })).isRequired,

  /** String. must match on of navItems keys */
  activeItemKey: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
};
var _default = NavigationBar;
exports.default = _default;